import palette from '../palette';

export default {
  root: {
    fontSize: 'inherit',
    color: palette.icon,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    }
  }
};
